import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { App } from './App';
import './analytics-release';
import './styles/global.css';
import './styles/hero-override.css';
import './styles/youtube-hero.css';
import './styles/layout-override.css';
import './styles/nav-alignment.css';
import './styles/cro.css';
import './styles/seo.css';

createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter><App /></BrowserRouter></StrictMode>);

const loadAccessibilityWidget = () => {
  if (document.querySelector('script[data-kim-userway]')) return;
  const script = document.createElement('script');
  script.src = 'https://cdn.userway.org/widget.js';
  script.dataset.account = 'u6JIPEFOHO';
  script.dataset.kimUserway = 'true';
  script.async = true;
  document.body.append(script);
};
const activateAccessibilityWidget = () => {
  loadAccessibilityWidget();
  window.removeEventListener('pointerdown', activateAccessibilityWidget);
  window.removeEventListener('keydown', activateAccessibilityWidget);
  window.removeEventListener('touchstart', activateAccessibilityWidget);
};
window.addEventListener('pointerdown', activateAccessibilityWidget, { once: true, passive: true });
window.addEventListener('keydown', activateAccessibilityWidget, { once: true });
window.addEventListener('touchstart', activateAccessibilityWidget, { once: true, passive: true });
window.setTimeout(activateAccessibilityWidget, 12000);
